module.exports = __webpack_public_path__ + "static/fonts/Fact-Light.2f984b5.eot";